mtl.alloy.factory.layoutHeader = (function($) {
    'use strict';

    /**
     * Get the window scroll-top position.
     */
    function getWindowScrollTop() {

        return window.pageYOffset * 1;

    }


    /**
     * Watch scrolling and update the minimised status accordingly.
     */
    function minimiseHandler(element, options) {

        var $element = $(element);
        element = $element[0];

        var isMinimised = false;
        var scrollPositionWas = 0;
        var scrollCatch = 0;


        /**
         * Update the minimised status of the header.
         */
        function update() {

            var scrollPosition = getWindowScrollTop();
            var scrollDiff = scrollPosition - scrollPositionWas;

            var makeMinimised = isMinimised;

            if (scrollDiff < 0 || scrollPosition < 150) {
                if (scrollPosition < scrollCatch - 30) {
                    makeMinimised = false;
                }
                if (!makeMinimised) {
                    scrollCatch = Math.min(scrollCatch, scrollPosition);
                }
            }

            else if (scrollDiff > 0) {
                if (scrollPosition > scrollCatch + 10) {
                    makeMinimised = true;
                }
                if (makeMinimised) {
                    scrollCatch = Math.max(scrollCatch, scrollPosition);
                }
            }

            if (makeMinimised !== isMinimised) {
                $element.toggleClass('is-minimised', (isMinimised = makeMinimised));
            }

            scrollPositionWas = scrollPosition;

        }


        // Listen for scroll events to update the minimised status
        $(window).on('scroll orientationchange', util.throttle(update, 100));

        // Initialise the minimised status
        update();

    }


    /**
     * Show or hide the off-canvas menu when clicking the menu button.
     */
    function menuHandler(element, options) {

        var $element = $(element);
        element = $element[0];

        var $body = $(document.body);

        var supportedBreakpoints = 'phone phone-l';
        var showClass = 'show-ocm';


        /**
         * Show the off-canvas menu.
         */
        function showMenu() {

            if (util.breakpoint.not(supportedBreakpoints)) {
                return;
            }

            $body.addClass(showClass);

        }


        /**
         * Hide the off-canvas menu.
         */
        function hideMenu() {

            $body.removeClass(showClass);

        }


        /**
         * Toggle the off-canvas menu.
         */
        function toggleMenu() {

            if ($body.hasClass(showClass)) {
                hideMenu();
            }
            else {
                showMenu();
            }

        }


        // Listen for clicks on the menu button
        $element.on('click', '[data-ref="menu-btn"]', toggleMenu);

        // Hide the menu when leaving supported breakpoints
        util.breakpoint.when(supportedBreakpoints, null, hideMenu);

    }


    /**
     * Return the layout-header factory function.
     */
    return function(element, options) {

        minimiseHandler(element, options);
        menuHandler(element, options);

    };

}(jQuery));
